import React from 'react';
import * as _ from 'lodash';
import dialogLoader from '../utilities/dialogLoader';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import Joi from 'joi-browser';
import regex from '../utilities/validateRegex';
import { validateByJoi } from '../utilities/validation';
import Helmet from 'react-helmet';
import {
  USER_ROLES,
  HEADER_CONSTANTS, // ヘッダータイトル
  INTEGRATE_USER_COMMON_ERROR_MESSAGE,
  INTEGRATE_USER_SUCCESS_TITLE,
  INTEGRATE_USER_SUCCESS_MESSAGE,
} from '../utilities/constants';
import { ForemanForm } from '../components/forms/Foreman'; // フォーム
import { CloseEditView } from '../components/CloseEditView';
import { UserService } from '../services/Users';
import { CompanyBranchService } from '../services/CompanyBranches'; // 協力会社API
import ImageUtility from '../utilities/imageUtility';
import { ImageDialog } from '../components/modals/ImageDialog';
import { Modal } from '../components/Modal';
import { DialogSuccessError } from '../components/modals/DialogSuccessError';
import { messageUtility } from '../utilities/messageUtility';
import { formatTel } from '../utilities/stringUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { ConfirmIntegrateUserDialog } from '../components/modals/ConfirmIntegrateUserDialog';
import { LoginUserGroupsService } from '../services/LoginUserGroups';
import { ConfirmExistedEmailDialog } from '../components/modals/ConfirmExistedEmailDialog';
import { IntegrateError } from '../components/modals/IntegrateError';
import Information from '../components/modals/common/Information';
import EventManager, { EventType } from '../utilities/EventManager';
import { ForemanRegistConfirmDialog } from '../components/modals/ForemanRegistConfirmDialog';

/**
 * 協力会社ユーザ登録
 *
 * @export
 * @class ForemanRegister
 * @extends {React.Component}
 */
export class ForemanRegister extends React.Component {
  constructor(props) {
    super(props);

    // パラメータ分解
    const param = this.props.view.state.id.split('.');

    // 必須項目名
    const requiredInputColumns = [
      //'user_role_code',
      'name_sei',
      'name_mei',
      'kana_sei',
      'kana_mei',
      'login_id',
      // 'password',
      // 'password_confirmation',
    ];

    this.state = {
      partnerCompanyId: param[0], // 協力会社ID
      companyBranchId: param[1], // 支店ID
      // passwordVisible: false, // パスワード表示フラグ
      requiredInput: {
        // 必須入力項目
        columns: requiredInputColumns,
        // 必須総数
        total: requiredInputColumns.length,
        count: 0, // 入力数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      image: {
        // アップロード画像
        file: '', // バイナリ
        path: '', // 画像URL
        isSet: false, // 画像セットフラグ
      },
      formValues: {
        company_branch_id: param[1], // 支店ID
        user_role_code: USER_ROLES.foreman.id, // ユーザー種別
        company_name: '', // 所属会社
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        email: '', // メールアドレス
        login_id: '', // ユーザーID
        // password: '', // パスワード
        // password_confirmation: '', // パスワード確認用
        tel: '', // 電話番号
      },
      companyAddress: '',
      showConfirmation: false,
      isShowPopupConfirmIntegrateUser: false,
      isShowPopupExistedEmail: false,
      isShowPopupIntegrateUserError: false,
      isIntegrateSuccess: false,
      isShowPopupInfo: false,
      userIntegrates: [],
      checkIntegrateError: false,
      messageIntegrate: '',
    };
    this.isSubmittingFlag = false;

    // バリデーションパターン
    this.schema = Joi.object().keys({
      company_branch_id: Joi.string(), // 支店ID
      user_role_code: Joi.number(), // ユーザー種別
      company_name: Joi.string(), // 所属会社
      name_sei: Joi.string()
        .required()
        .max(64), // 姓
      name_mei: Joi.string()
        .required()
        .max(64), // 名
      kana_sei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128), // せい
      kana_mei: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(128), // めい
      email: Joi.string()
        .label('email')
        .regex(regex.pattern.email)
        .max(255)
        .allow(null, ''), // メールアドレス
      login_id: Joi.string()
        .label('pwd')
        .regex(regex.pattern.pwd)
        .required()
        .max(60), // ユーザーID
      // password: Joi.string()
      //   .label('pwdPWD32')
      //   .regex(regex.pattern.pwdPWD32)
      //   .max(32)
      //   .required(), // パスワード
      // password_confirmation: Joi.string()
      //   .label('pwdPWD32')
      //   .regex(regex.pattern.pwdPWD32)
      //   .max(32)
      //   .required(), // パスワード確認用
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .allow(null, ''), // 電話番号(各フォームのMAX_LENGTHはcomponentにて制御)
    });

    this.imageExists = this.imageExists.bind(this); // 画像判定

    // イベント登録
    this.events = {
      dialog: {
        // ダイアログ
        goBack: this.handleGoBackDialog.bind(this), // 閉じる
      },
      form: {
        // フォーム関連
        set: this.setData.bind(this), // 会社情報入力
        isAvailable: this.isAvailable.bind(this), // バリデーション
        setImage: this.setImage.bind(this), // 画像アップ
        submit: this.submit.bind(this), // 登録
        deleteImage: this.deleteImage.bind(this), // 画像削除
        // handlePasswordVisibleToggle: this.handlePasswordVisibleToggle.bind(
        //   this
        // ), // パスワード表示・非表示
      },
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          const id = `${this.state.partnerCompanyId}.${
            this.state.companyBranchId
          }`;
          _masterSlideLoader.show('PartnerUsers', { state: { id } });
          dialogLoader.close();
        },
      },
    };
  }

  componentDidMount() {
    const param = {
      company_branch_id: this.state.companyBranchId,
    };
    // 協力会社情報取得
    CompanyBranchService.show(this.state.partnerCompanyId, param).then(
      response => {
        if (response.result) {
          const { company } = response.data.entities;
          let formValues = this.state.formValues;
          formValues.company_name = response.data.entities.company.name;
          const companyAddress =
            (company.prefecture_name || '') +
            (company.city_name || '') +
            (company.street_number || '') +
            (company.building_name || '');
          this.setState({ formValues, companyAddress });
        }
      }
    );
  }

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  // /**
  //  * パスワード表示・非表示
  //  */
  // handlePasswordVisibleToggle = () => {
  //   this.setState({ passwordVisible: !this.state.passwordVisible });
  // };

  /**
   * 入力
   */
  setData = (name, value) => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[name] = value;

    this.setState({
      formValues,
    });
  };
  setRequiredCount = () => {
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const formValues = _.cloneDeep(this.state.formValues);
    let cnt = 0;
    _.each(this.state.requiredInput.columns, column => {
      if (formValues[column] && !this.state.validate.messages[column]) {
        cnt++;
      }
    });
    requiredInput.count = cnt;

    this.setState({
      requiredInput,
    });
  };

  /**
   * 画像アップロード
   */
  setImage = e => {
    let createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    let image = this.state.image;
    if (!e.target.files[0]) {
      return;
    }
    let url = createObjectURL(e.target.files[0]);
    this.imageExists(url, e.target, async (loaded, target) => {
      const size = await ImageUtility.fileSizeCheck(target.files[0]);
      const type = await ImageUtility.fileTypeCheck(target.files[0]);
      // filetype,filesizeをチェック、errorが無ければイメージをセット
      if (!type) {
        this.imageTypeErrorDialog();
      } else if (!size) {
        this.imageSizeErrorDialog();
      } else {
        image.path = url;
        image.file = target;
        image.isSet = true;
      }
      this.setState({ image });
    });
  };

  /**
   * 画像TypeErrorダイアログ表示
   */
  imageTypeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: '選択可能な画像形式は「JPEG、GIF、PNG」ファイルです',
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像SizeErrorダイアログ表示
   */
  imageSizeErrorDialog = () => {
    dialogLoader.show(
      ImageDialog,
      {
        message: messageUtility.getMessage('E-000-011'),
        callback: {
          confirm: () => {
            dialogLoader.close();
          },
        },
      },
      null
    );
  };

  /**
   * 画像判定
   * @param url {string}
   */
  imageExists(url, target, callback) {
    var img = new Image();
    img.src = url;
    img.onload = () => {
      callback(true, target);
    };
    img.onerror = () => {
      callback(false);
    };
  }

  /**
   * 画像削除
   */
  deleteImage = () => {
    let image = { ...this.state.image };
    image.path = '';
    image.file = '';
    image.isSet = false;
    this.setState({ image });
    // onChangeイベントを感知
    document.getElementById('file-foreman-image').value = '';
  };

  /**
   * 入力値の有効判定
   * @return bool
   */
  isAvailable = (e, targetName) => {
    const values = _.cloneDeep(this.state.formValues);
    const validate = _.cloneDeep(this.state.validate);
    const result = validateByJoi(this.schema, values);
    const available = result.result;

    // if  - onBlur時に入力チェック
    // else- submit(登録ボタン押下)時に必須項目チェック
    if (e) {
      let name = _.isEmpty(targetName) ? e.target.name : targetName;
      if (_.has(result.messages, name)) {
        validate.messages[name] = result.messages[name];
      } else if (_.has(validate.messages, name)) {
        delete validate.messages[name];
      }
    } else {
      if (!available) {
        _.each(result.messages, (value, key) => {
          validate.messages[key] = result.messages[key];
        });
      } else {
        validate.messages = {};
      }
    }
    // // パスワードを正しく入力済みか
    // if (
    //   !_.has(result.messages, 'password') &&
    //   !_.has(result.messages, 'password_confirmation')
    // ) {
    //   // パスワードとパスワード確認の値が違えばerror
    //   if (values.password !== values.password_confirmation) {
    //     validate.messages.password_confirmation = 'パスワードが一致しません。';
    //   } else if (values.password === values.password_confirmation) {
    //     delete validate.messages.password_confirmation;
    //   }
    // }

    // error有無チェック、フラグ変更
    if (Object.keys(validate.messages).length !== 0) {
      validate.invalid = true;
    } else {
      validate.invalid = false;
    }

    this.setState({ validate }, () => {
      this.setRequiredCount();
    });
    return validate.invalid;
  };

  /**
   * 登録
   */
  submit = () => {
    this.setState({
      isShowPopupConfirmIntegrateUser: false,
      isShowPopupExistedEmail: false,
    });
    if (this.isAvailable()) {
      return;
    }
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;

    let values = _.cloneDeep(this.state.formValues);
    // 画像セット
    if (this.state.image.isSet) {
      _.assign(values, { user_image: this.state.image.file });
    }
    values.tel = formatTel(values.tel);

    UserService.create(values)
      .then(response => {
        this.closeConfirmationDialog();
        if (response.result) {
          // console.log('debug response.message', response.message);
          dialogLoader.show(SubmitDialog, this.GoBack);
        } else {
          // 200以外はここを通る
          let errorMessage = '';
          // messageにエラーメッセージがあるとき
          if (response.data && response.data.message !== '') {
            errorMessage = response.data.message;
          } else {
            // errorに入ってないときは安全にデフォルトのエラーメッセージ
            errorMessage = messageUtility.getMessage('E-000-001');
          }

          // モーダルの表示(通信エラー)
          this.setState({
            showModal: true,
            updateSuccess: false,
            updateMsg: messageUtility.getMessage('E-001-402'),
            updateMsgDetail: errorMessage,
          });
        }
      })
      .catch(error => {
        let errorMessage = '';
        // errorにちゃんと入ってた場合
        if (error && error.length > 0) {
          errorMessage = error[0].responseJSON.message;
        } else {
          // errorに入ってないときは安全にデフォルトのエラーメッセージ
          errorMessage = messageUtility.getMessage('E-000-001');
        }

        // モーダルの表示(通信エラー)
        this.setState({
          showModal: true,
          updateSuccess: false,
          updateMsg: messageUtility.getMessage('E-001-402'),
          updateMsgDetail: errorMessage,
        });
      })
      .finally(() => {
        this.isSubmittingFlag = false;
      });
  };

  showConfirmationDialog = () => {
    if (this.isAvailable()) {
      return;
    }
    this.setState({
      showConfirmation: true,
    });
  };
  closeConfirmationDialog = () => {
    this.setState({
      showConfirmation: false,
    });
  };

  checkIntegrateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const values = this.state.formValues;
    const params = {
      email: values.email,
      user_role_code: values.user_role_code,
      company_branch_id: values.company_branch_id,
    };
    const { data, result } = await LoginUserGroupsService.checkIntegrate(
      params
    );
    this.isSubmittingFlag = false;
    this.toggleDialog('isShowPopupExistedEmail', false);
    if (result) {
      return this.setState({
        userIntegrates: _.get(data, 'entities.users'),
        isShowPopupConfirmIntegrateUser: true,
      });
    }
    this.setState({
      messageIntegrate: _.get(data, 'message'),
      isShowPopupIntegrateUserError: true,
    });
  };

  handleIntegrateUser = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    let values = _.cloneDeep(this.state.formValues);
    if (this.state.image.isSet) {
      _.assign(values, { user_image: this.state.image.file });
    }
    values.tel = formatTel(values.tel);
    const { result } = await UserService.createIntegrate(values);
    this.isSubmittingFlag = false;
    this.toggleDialog('isShowPopupConfirmIntegrateUser', false);
    if (result) {
      EventManager.trigger(EventType.REFRESH_PROFILE);
      return this.setState({
        isIntegrateSuccess: true,
        isShowPopupInfo: true,
      });
    }
    this.setState({
      isIntegrateSuccess: false,
      isShowPopupInfo: true,
    });
  };

  checkDuplicateEmail = async () => {
    if (this.isAvailable() || this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const values = _.cloneDeep(this.state.formValues);
    const params = {
      email: values.email,
      user_role_code: values.user_role_code,
      company_branch_id: values.company_branch_id,
    };
    const { result } = await LoginUserGroupsService.checkDuplicateEmail(params);
    this.isSubmittingFlag = false;
    if (result) {
      return this.toggleDialog('isShowPopupExistedEmail', true);
    }
    this.toggleDialog('showConfirmation', true);
  };

  toggleDialog = (key, value) => {
    this.setState({ [key]: value }, () => {
      if (this.state.isIntegrateSuccess) {
        const id = `${this.state.partnerCompanyId}.${
          this.state.companyBranchId
        }`;
        _masterSlideLoader.show('PartnerUsers', { state: { id } });
      }
    });
  };

  render() {
    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 職長新規登録</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title='職長新規登録'
            onClose={() => this.events.dialog.goBack()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__menu'>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn--effective'
                      onClick={this.checkDuplicateEmail}
                    >
                      登録
                    </button>
                  </span>
                  <span
                    className='contruction-detail-view__end-item'
                    style={{
                      right: '140px',
                      color: '#E64E17',
                      fontSize: '12px',
                    }}
                  >
                    {this.state.validate.invalid
                      ? '入力エラーがあります。'
                      : ''}
                  </span>
                  <div className='contruction-detail-view__end-item'>
                    {`必須項目の入力数 ${this.state.requiredInput.count}/${
                      this.state.requiredInput.total
                    }`}
                  </div>
                </div>
                <div className='contruction-detail-view__bar' />
                <ForemanForm
                  values={this.state.formValues}
                  events={this.events.form}
                  messages={this.state.validate.messages}
                  // passwordVisible={this.state.passwordVisible}
                  image={this.state.image.path}
                />
              </div>
              <Modal modalRoot='root' modalState={this.state.showModal}>
                <DialogSuccessError
                  msg={this.state.updateMsg}
                  msgDetail={this.state.updateMsgDetail}
                  updateSuccess={this.state.updateSuccess}
                  success={this.state.jumpTo}
                  error={() => this.setState({ showModal: false })}
                  multilineText={true}
                  labelBtnError={messageUtility.getMessage('I-000-017')}
                />
              </Modal>
            </div>
          </div>
        </div>
        <ForemanRegistConfirmDialog
          visible={this.state.showConfirmation}
          onCancel={this.closeConfirmationDialog}
          onConfirm={this.submit}
          companyName={this.state.formValues.company_name}
          companyAddress={this.state.companyAddress}
          values={this.state.formValues}
        />

        <ConfirmExistedEmailDialog
          visible={this.state.isShowPopupExistedEmail}
          userRoleCode={this.state.formValues.user_role_code}
          onCancel={() => this.toggleDialog('isShowPopupExistedEmail', false)}
          isCreateNew={true}
          onConfirmNotIntegrate={() => {
            this.toggleDialog('isShowPopupExistedEmail', false);
            this.toggleDialog('showConfirmation', true);
          }}
          onConfirmIntegrate={this.checkIntegrateUser}
        />

        <ConfirmIntegrateUserDialog
          visible={this.state.isShowPopupConfirmIntegrateUser}
          onCancel={() =>
            this.toggleDialog('isShowPopupConfirmIntegrateUser', false)
          }
          onConfirm={this.handleIntegrateUser}
          data={this.state.userIntegrates}
        />

        <IntegrateError
          reason={this.state.messageIntegrate}
          visible={this.state.isShowPopupIntegrateUserError}
          userRoleCode={this.state.formValues.user_role_code}
          isCreateNew={true}
          onConfirm={() => {
            this.toggleDialog('isShowPopupIntegrateUserError', false);
            this.toggleDialog('showConfirmation', true);
          }}
          onCancel={() =>
            this.toggleDialog('isShowPopupIntegrateUserError', false)
          }
        />

        <Information
          visible={this.state.isShowPopupInfo}
          title={
            this.state.isIntegrateSuccess
              ? INTEGRATE_USER_SUCCESS_TITLE
              : messageUtility.getMessage('E-001-402')
          }
          message={
            this.state.isIntegrateSuccess
              ? INTEGRATE_USER_SUCCESS_MESSAGE
              : INTEGRATE_USER_COMMON_ERROR_MESSAGE
          }
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.toggleDialog('isShowPopupInfo', false)}
          multilineText={true}
        />
      </div>
    );
  }
}

/**
 * 登録完了ダイアログ
 */
class SubmitDialog extends React.Component {
  render() {
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>ユーザー登録完了</span>
        </div>
        <div className='dialog-md__body text-left'>
          ユーザーの登録が完了しました。
        </div>
        <div className='dialog-md__footer'>
          <button
            id='modal-close-copy'
            className='btn--sub'
            onClick={() => {
              this.props.dialog.callback.clear();
            }}
          >
            {messageUtility.getMessage('I-000-017')}
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ForemanRegister.jsx